import * as React from 'react';
import { toast } from 'react-toastify';
import { formatNumber } from '../Common/Utilities';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';

export default class PODetails extends React.Component {
	constructor() {
		super();

		this.state = {
			data: [],
			lastUpdated: ""
		};
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
	}
	getRefreshButton = () => {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}

	refresh_clickHandler(event) {
		this.props.info.inProgress(true);

		let functionName = "getpodetail";
		let messageName = "PO Detail";
		httpGet("/api/Adapter/getSyncData/" + functionName)
			.then(response => {
				var data = response.data;
				this.props.info.inProgress(false);
				if (data)
					toast.success(messageName + ' Fetched Successfully');
				else
					toast.error('Error fetching ' + messageName);

			}).catch((error) => {
				this.props.info.inProgress(false);
				toast.error('Error fetching ' + messageName);
			});
	}
	componentDidMount() {
		this.fetchPODetails();
	}

	fetchPODetails() {
		var that = this;

		this.props.info.inProgress(true);

		httpGet('/api/setup/PODetails?poCode=' + encodeURIComponent(this.props.info.poCode))
			.then((response) => {
				var data = response.data;

				var localDateString = data.lastUpdated == null ? "" : new Date(data.lastUpdated).toLocaleString();
				let records = (data.records || []).map((e, i) => { let d = { ...e, rowId: i }; return d; });
				that.setState({ data: records, lastUpdated: localDateString });

				this.props.info.inProgress(false);
			})
			.catch((error) => {
				this.props.info.inProgress(false);
				toast.error('An error occurred while fetching the records');
				console.error('There was an error!', error);
			});
	}

	render() {
		const cellStyle = { paddingLeft: 8, paddingRight: 42 };
		const headerStyle = { textAlign: 'right' };

		return (
			<div>
				<h1>Purchase Order Details  {this.props.info.poCode && <span>({this.props.info.poCode})</span>}</h1>
				<div className="form-group">
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							title={"Last Updated: " + this.state.lastUpdated}
							customcomponent={this.getRefreshButton()}
							columns={[
								{
									headerName: 'Line #',
									field: 'lineId',
									width: 70,

								},
								{
									headerName: 'Project',
									field: 'level2Key',
									flex: 1
								},
								{
									headerName: 'Activity',
									field: 'level3Key',
									flex: 1
								},
								{
									headerName: 'Due Date',
									field: 'dueDate',
									type: 'date',
									valueGetter: ({ value }) => (value && new Date(value)),
									flex: 1
								},
								{
									headerName: 'Quantity',
									field: 'quantity',
									type: 'numeric',
									headerAlign: 'right',
									align: 'right',
									valueGetter: ({ value }) => (value && Number(value)) || 0,
									flex: 1
								},
								{
									headerName: 'Net Cost',
									field: 'netCost',
									type: 'currency',
									headerAlign: 'right',
									align: 'right',
									renderCell: rowData => formatNumber(rowData.row.netCost) + " " + this.props.info.currencyCode,
									flex: 1
								},
								{
									headerName: 'Match to Date Net',
									field: 'matchToDateNet',
									type: 'numeric',
									headerAlign: 'right',
									align: 'right',
									valueGetter: ({ value }) => (value && Number(value)) || 0,
									flex: 1
								},
								{
									headerName: 'Closed',
									field: 'closeFlag',
									renderCell: rowData => { return rowData.row.closeFlag === 1 ? "Y" : "N"; },
									flex: 1
								}

							]}
							getRowId={(row) => row.rowId}
							disableSelectionOnClick
						/>
					</div>
					
				</div>
			</div>
		);
	}
}
